import { render } from "./Subscriptions.vue?vue&type=template&id=c30d564a&ts=true"
import script from "./Subscriptions.vue?vue&type=script&lang=ts"
export * from "./Subscriptions.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__